/** Extract the in-app editor path (/transit-operation/{id}) from a relative path or an absolute
 *  http(s) URL. Returns the path (always same-origin, in-app) or null. Used to open the draft in the
 *  current client regardless of the absolute host the copilot put in openUrl. */
// A draft id is a positive integer — `0` means "no draft" (e.g. a search-only turn), never an openable page.
const TRANSIT_OP_PATH = /^\/transit-operation\/[1-9]\d*$/

export function editorPath(url: string): string | null {
  if (typeof url !== 'string' || url.length === 0) return null
  if (TRANSIT_OP_PATH.test(url)) return url
  try {
    const u = new URL(url)
    if ((u.protocol === 'https:' || u.protocol === 'http:') && TRANSIT_OP_PATH.test(u.pathname)) {
      return u.pathname
    }
  } catch { /* not absolute */ }
  return null
}
